import { Settings } from 'features/settings/ui/Settings'

export const SettingsPage = () => {
    return (
        <Settings />
    )
}